<template>
  <li :class="componentClassName">
    <span v-if="number" class="a-progress-step-number">
      <a-icon v-if="state === 'completed'" icon="check-large" color="white" />
    </span>
    <span class="a-progress-step-label">{{ label }}</span>

    <div v-if="steps" class="a-progress-step-inner">
      <span v-if="subStepLabel" class="a-progress-step-label">{{ subStepLabel }}</span>
      <ol :class="subStepListClassName">
        <a-progress-step
          v-for="(item, key) in listSubStep"
          :key="key"
          :label="item.label"
          :state="item.state"
          :show-number="item.showNumber"
          :highlight-current="item.highlightCurrent"
          :number="false"
        />
      </ol>
    </div>
  </li>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AIcon from '@/components/atoms/icon/index.vue';

export default {
  name: 'a-progress-step',
  components: {
    AIcon,
  },
  props: {
    state: {
      type: String,
      default: null,
      validator(value) {
        return value.match(/(null|current|completed)/);
      },
    },
    class: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: null,
    },
    number: {
      type: Boolean,
      default: true,
    },
    subStepLabel: {
      type: String,
      default: null,
    },
    steps: {
      type: Array,
      default: null,
    },
    currentStep: {
      type: Number,
      default: 1,
    },
    highlightCurrent: {
      type: Boolean,
      default: true,
    },
    showNumber: {
      type: Boolean,
      default: true,
    },
    highlightSubStepCurrent: {
      type: Boolean,
      default: true,
    },
    showSubStepNumber: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers(
        'a-progress-step',
        this.state,
        this.steps ? 'expand' : '',
        this.highlightCurrent ? '' : 'no-highlight',
        this.showNumber ? '' : 'no-number'
      );
      return `${baseClassName} ${this.class}`.trim();
    },
    listSubStep() {
      return this.steps.map((label, index) => {
        const step = {
          label,
          state: null,
          number: true,
          subStep: false,
          showNumber: this.showSubStepNumber,
          highlightCurrent: this.highlightSubStepCurrent,
        };
        const stepVal = index + 1;
        if (stepVal < this.currentStep) {
          step.state = 'completed';
        } else if (stepVal === this.currentStep) {
          step.state = 'current';
        } else if (this.state === 'completed') {
          step.state = 'completed';
        }

        return step;
      });
    },
    subStepListClassName() {
      return mapModifiers('a-progress-step-list', this.showSubStepNumber ? '' : 'no-number');
    },
  },
};
</script>
